<template>
    <div class="accordion" id="packet-info-parent">
        <div class="accordion-item">
            <h2 class="accordion-header" id="packet-info">
                <button class="accordion-button" type="button" @click="$helper.toggleAccordion(($store.state.inClientAdmin ? 5 : 3), true);">
                    {{ $helper.trans('Shipment_information') }}
                </button>
            </h2>
            <div id="packet-info-content" class="accordion-collapse collapse" aria-labelledby="packet-info" data-parent="#packet-info-parent">
                <div class="accordion-body">
                    <div class="packet-box-info packages_display_container" v-if="!$store.state.inClientAdmin && !$store.state.currentActions.editingPackages">
                        <span class="packet-info-label mb-2"><strong>{{ $helper.trans('Total_packages') }}:</strong> {{ $store.state.packagesDimensions.length }}</span>
                        <span class="packet-title" v-for="(packagesDimension, packageIndex) in $store.state.packagesDimensions" :key="packageIndex">
                            <div v-if="!$store.state.quickEditDimensions" @click="toggleEdit(true)">
                                {{ ($store.state.packagesDimensions.length > 1 ? (packageIndex + 1) : '') }}
                                {{ ($store.state.packageType !== '04' ? packageType.toLowerCase() : packageType) }}
                                {{ packagesDimension.weight }}kg <span v-if="$store.state.packageType === '02'">({{ packagesDimension.length }}cm x {{ packagesDimension.width }}cm x {{ packagesDimension.height }}cm) </span>
                                <button @click="openPackageEdit()" v-if="packageIndex === 0" class="icon-pencil"></button>
                            </div>
                            <div v-else>
                                <input type="text" @input="validatePackageValue(packageIndex, 'weight')" class="input-sm mr-1 edit-dimensions-width" v-model="$store.state.packagesDimensions[packageIndex].weight" />kg
                                <span v-if="$store.state.packageType === '02'">
                                    <input type="text" @input="validatePackageValue(packageIndex, 'length')" class="input-sm mr-1 ml-2 edit-dimensions-width" v-model="$store.state.packagesDimensions[packageIndex].length" />cm x
                                    <input type="text" @input="validatePackageValue(packageIndex, 'width')" class="input-sm mr-1 ml-2 edit-dimensions-width" v-model="$store.state.packagesDimensions[packageIndex].width" />cm x
                                    <input type="text" @input="validatePackageValue(packageIndex, 'height')" class="input-sm mr-1 ml-2 edit-dimensions-width" v-model="$store.state.packagesDimensions[packageIndex].height" />cm
                                </span>
                                <i class="fa fa-times cancel-edit" aria-hidden="true" @click="toggleEdit(false)"></i>

                                <button v-if="quickEditBtn" type="button" @click="recalculate()" class="btn btn-yellow radius-4 d-block mt-2">{{ $helper.trans('Recalculate') }}</button>
                                <span v-if="errorMessage" style="display: block;color: red;">{{ errorMessage }}</span>

                                <div class="price-option-line justify-content-center align-items-center" v-if="$store.state.currentActions.gettingShippingOptions">
                                    {{ $helper.trans('Search_for_services') }}
                                    <i class="fa fa-cog fa-spin fa-2x ml-2"></i>
                                </div>

                            </div>
                        </span>
                        <span class="packet-info-label"><strong>{{ $helper.trans('Service') }}: </strong>{{ $store.state.selectedShippingOption.serviceName }}</span>
                        <span class="packet-info-label">
                            <strong> {{ $helper.trans('Estimated_delivery_time') }}: </strong>
                            <span v-html="formattedEstimatedDelivery"></span>
                        </span>
                        <span class="packet-info-label"><strong>{{ $helper.trans('Take_From') }}: </strong> {{ fullShipperAddress }}, {{ $store.state.shipperAddressInformation.city }} {{ $store.state.from.country.toUpperCase() }}-{{ $store.state.from.postCode }}, {{ $store.state.from.countryName }}</span>
                        <span class="packet-info-label"><strong>{{ $helper.trans('Delivery_to') }}: </strong> {{ fullDeliveryAddress }}, {{ $store.state.deliveryAddressInformation.city }}, {{ $store.state.to.country.toUpperCase() }}-{{ $store.state.to.postCode }}, {{ $store.state.to.countryName }}</span>
                    </div>

                    <div class="packet-box-info edit-wrap packages_edit_container" v-if="$store.state.currentActions.editingPackages">
                        <div class="packet-row packet-column">
                            <label class="options-line-label size-16">{{ $helper.trans('Package_type') }}:</label>
                            <div class="options-navig-block row-4">
                                <div class="options-navig-column custom-radio-border column-4">
                                    <input type="radio" v-model="$store.state.packageType" value="01" id="packet-1" class="input-country input-big">
                                    <label for="packet-1" id="label-packet-1">{{ $helper.trans('Envelope') }}</label>
                                </div>
                                <div class="options-navig-column custom-radio-border column-4">
                                    <input type="radio" v-model="$store.state.packageType" value="04" id="packet-3" class="input-country input-big">
                                    <label for="packet-3" id="label-packet-3">{{ $helper.trans('UPS_Package') }}</label>
                                </div>
                                <div class="options-navig-column custom-radio-border column-4">
                                    <input type="radio" v-model="$store.state.packageType" value="02" id="packet-2" class="input-country input-big" checked>
                                    <label for="packet-2" id="label-packet-2">{{ $helper.trans('Box') }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="packet-row packet-column">
                            <label class="options-line-label size-16">{{ $helper.trans('Package_dimensions') }}:</label>
                            <package-dimensions-line v-for="(packagesDimension, packageIndex) in $store.state.packagesDimensions" :key="packageIndex" :index="packageIndex" :isEdit="true" />
                        </div>
                        <div class="packet-row packet-column">
                            <label class="options-line-label size-16">{{ $helper.trans('Service') }}:</label>
                            <shipping-options-component @optionSelected="selectShippingOption();" :isEdit="true" />
                        </div>
                    </div>
                    <div v-show="$store.state.selectedFormType === 'single'">
                        <div v-show="$store.state.selectedShippingType === 'export'" class="packet-row packet-checkbox" v-if="$store.state.$siteSettings.isc_bio || $store.state.$siteSettings.isc_other">
                            <label for="ch-1" class="custom-checkbox-wrap" v-if="$store.state.$siteSettings.isc_bio">
                                {{ $helper.trans('ISC_BIO') }}
                                <input type="checkbox" v-model="$store.state.otherDeliveryInformation.iscBio" id="ch-1" :value="1">
                                <span class="checkmark"></span>
                            </label>
                            <label for="ch-2" class="custom-checkbox-wrap" v-if="$store.state.$siteSettings.isc_other">
                                {{ $helper.trans('ISC_Other') }}
                                <input type="checkbox" v-model="$store.state.otherDeliveryInformation.iscOther" id="ch-2" :value="1">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="packet-row packet-checkbox">
                            <label for="ch-3" class="custom-checkbox-wrap">
                                {{ $helper.trans('Check_if_documents') }}
                                <input type="checkbox" v-model="$store.state.otherDeliveryInformation.isDocuments" id="ch-3">
                                <span class="checkmark"></span>
                            </label>
                            <label for="ch-4" class="custom-checkbox-wrap">
                                {{ $helper.trans('Mark_if_the_package_contains_batteries') }}
                                <input type="checkbox" v-model="$store.state.otherDeliveryInformation.hasBatteries" id="ch-4" :value="1">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="notification d-block prohibited-items-alert bg-red spacer-16" style="width: 100%;" v-if="$store.state.customValues.letterSwapped && $store.state.$siteSettings['Logged_in']">
                            <h3>{{ $helper.trans('Important') }}</h3>
                            <p v-show="$store.state.inClientAdmin">{{ $helper.trans('Uncheck_documents_message') }}</p>
                            <p v-show="!$store.state.inClientAdmin">{{ $helper.trans('Uncheck_documents_message_unregistered') }}</p>
                            <p v-show="!$store.state.awaitingActions.hasSameService">{{ $helper.trans('Does_not_have_price_by_same_service') }}</p>
                        </div>
                        <div class="notification d-block prohibited-items-alert bg-red spacer-16" style="width: 100%;" v-if="$store.state.customValues.letterSwapped && !$store.state.$siteSettings['Logged_in']">
                            <h3>{{ $helper.trans('Important') }}</h3>                       
                            <p>{{ $helper.trans('Uncheck_documents_message_unregistered') }}</p>
                            <p v-show="!$store.state.awaitingActions.hasSameService">{{ $helper.trans('Does_not_have_price_by_same_service') }}</p>
                        </div>
                        <div class="packet-row packet-column packet-textarea packet-line">
                            <label class="strong-label">{{ $helper.trans('Description_of_shipment') }}: *</label>
                            <div class="w-100">
                                <textarea class="otherDeliveryInformation_description_input w-100" v-model="$store.state.otherDeliveryInformation.description" :placeholder="$helper.trans('Summarize_description_of_shipment_in_English')" :disabled="$store.state.otherDeliveryInformation.isDocuments"></textarea>
                            </div>
                            <label class="normal-label">
                                {{ $helper.trans('Make_sure_you_are_not_sending') }}&nbsp;<a href="javascript:void(0);" data-toggle="modal" data-target="#forbidden_items_modal"> {{ $helper.trans('Prohibited_items') }}</a>
                            </label>
                            <div class="notification d-block prohibited-items-alert bg-red spacer-16" v-if="$store.state.otherDeliveryInformation.hasBatteries">
                                <h3>{{ $helper.trans('Important') }}</h3>
                                <p>{{ $helper.trans('You_are_sending_potentially_dangerous_goods') }}</p>
                            </div>
                        </div>

                        <div class="packet-row packet-column packet-line" v-show="!$store.state.otherDeliveryInformation.isDocuments">
                            <label class="strong-label label-margin">{{ $helper.trans('Parcel_insurance_title') }}:</label>
                            <div class="option-content option-content-row">

                                <div class="option-column mb-2 w-100" v-if="$store.state.packagesDimensions.length > 1">
                                    <label for="op-16" class="custom-checkbox-wrap">
                                        {{ $helper.trans('Difference_between_package_values') }}
                                        <input type="checkbox" v-model="$store.state.otherDeliveryInformation.packageValueDiff" id="op-16">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>

                                <div class="option-column" v-if="!$store.state.otherDeliveryInformation.packageValueDiff && !$store.state.otherDeliveryInformation.isDocuments">
                                    <input type="text" v-model="$store.state.packagesDimensions[0].insurance" :placeholder="$helper.trans('Parcel_insurance')" class="input-big mt-2 packages_0_insurance_input">
                                    <i class="fa fa-question-circle info-question-circle" style="position:absolute;">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Parcel_insurance_info')"></div>
                                        </div>
                                    </i>
                                </div>
                                <div class="option-content w-100" v-if="$store.state.otherDeliveryInformation.packageValueDiff && !$store.state.otherDeliveryInformation.isDocuments">
                                    <div class="option-column" v-for="(dimension, index) in $store.state.packagesDimensions" :key="index">
                                        <input type="text" v-model="$store.state.packagesDimensions[index].insurance" :placeholder="`${index + 1} ${$helper.trans('package_value')} ${dimension.weight}kg` + ($store.state.packageType === '02' ? ` ${dimension.length}x${dimension.width}x${dimension.height}` : '')" class="input-big mt-2" :class="`packages_${index}_insurance_input`">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="packet-row packet-column packet-option packet-line">
                            <label class="strong-label">{{ $helper.trans('Additional_options') }}: </label>
                            <div class="option-content">
                                <div class="checkbox-container">
                                    <label for="op-1" class="custom-checkbox-wrap">
                                        {{ $helper.trans('El_messages') }}
                                        <span class="service-tax" v-if="$store.state.otherDeliveryInformation.notifications && $store.state.$siteSettings['El_messages_tax'] > 0">(€{{ $store.state.$siteSettings['El_messages_tax'] }})</span>
                                        <input type="checkbox" v-model="$store.state.otherDeliveryInformation.notifications" id="op-1">
                                        <span class="checkmark"></span>
                                    </label>
                                    <i class="fa fa-question-circle info-question-circle">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('El_messages_info')"></div>
                                        </div>
                                    </i>
                                </div>
                                <div class="checkbox-container" v-if="signatureAvailable">
                                    <label for="op-2" class="custom-checkbox-wrap">
                                        {{ $helper.trans('Required_signatare') }}
                                        <span class="service-tax" v-if="$store.state.otherDeliveryInformation.requireSignature && $store.state.$siteSettings['Required_signatare_tax'] > 0">(€{{ $store.state.$siteSettings['Required_signatare_tax'] }})</span>
                                        <input type="checkbox" v-model="$store.state.otherDeliveryInformation.requireSignature" id="op-2" class="otherDeliveryInformation_requireSignature_input" @change="checkSignatureRule();">
                                        <span class="checkmark"></span>
                                    </label>
                                    <i class="fa fa-question-circle info-question-circle">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Required_signatare_info')"></div>
                                        </div>
                                    </i>
                                </div>
                                <div class="checkbox-container" v-if="directDeliveryAvailable">
                                    <label for="op-3" class="custom-checkbox-wrap">
                                        {{ $helper.trans('Only_direct_delivery') }}
                                        <span class="service-tax" v-if="$store.state.otherDeliveryInformation.directDelivery && $store.state.$siteSettings['Only_direct_delivery_tax'] > 0">(€{{ $store.state.$siteSettings['Only_direct_delivery_tax'] }})</span>
                                        <input type="checkbox" v-model="$store.state.otherDeliveryInformation.directDelivery" id="op-3">
                                        <span class="checkmark"></span>
                                    </label>
                                    <i class="fa fa-question-circle info-question-circle">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Only_direct_delivery_info')"></div>
                                        </div>
                                    </i>
                                </div>
                                <div class="checkbox-container" v-if="codAvailable">
                                    <label for="op-4" class="custom-checkbox-wrap">
                                        {{ $helper.trans('Cod') }}
                                        <span class="service-tax" v-if="$store.state.otherDeliveryInformation.cashOnDelivery && $store.state.$siteSettings['Cod_tax'] > 0">(€{{ codAmount }})</span>
                                        <input type="checkbox" v-model="$store.state.otherDeliveryInformation.cashOnDelivery" id="op-4" class="otherDeliveryInformation_cashOnDelivery_input">
                                        <span class="checkmark"></span>
                                    </label>
                                    <i class="fa fa-question-circle info-question-circle">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Cod_info')"></div>
                                        </div>
                                    </i>
                                </div>
                                <div class="checkbox-container" v-if="saturdayDeliveryAvailable">
                                    <label for="op-5" class="custom-checkbox-wrap">
                                        {{ $helper.trans('Saturday_delivery') }}
                                        <span class="service-tax" v-if="$store.state.otherDeliveryInformation.saturdayDelivery && saturdayDeliveryTax > 0">(€{{ saturdayDeliveryTax }})</span>
                                        <input class="otherDeliveryInformation_saturdayDelivery_input" type="checkbox" v-model="$store.state.otherDeliveryInformation.saturdayDelivery" id="op-5">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="checkbox-container" v-if="signatureAvailable">
                                    <label for="op-6" class="custom-checkbox-wrap">
                                        {{ $helper.trans('An_adult_signature_is_required') }}
                                        <input type="checkbox" v-model="$store.state.otherDeliveryInformation.adultSignature" id="op-6" class="otherDeliveryInformation_adultSignature_input" @change="checkSignatureRule();">
                                        <span class="checkmark"></span>
                                    </label>
                                    <span class="service-tax" v-if="$store.state.otherDeliveryInformation.adultSignature && $store.state.$siteSettings['An_adult_signature_is_required_tax'] > 0">(€{{ $store.state.$siteSettings['An_adult_signature_is_required_tax'] }})</span>
                                    <i class="fa fa-question-circle info-question-circle">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('An_adult_signature_is_required_info')"></div>
                                        </div>
                                    </i>
                                </div>
                                <div class="checkbox-container">
                                    <label for="registration_number_cb" class="custom-checkbox-wrap">
                                        {{ $helper.trans('Package_reg_ref_num') }}
                                        <input type="checkbox" v-model="$store.state.registrationNumberSelected" id="registration_number_cb" value="1">
                                        <span class="checkmark"></span>
                                    </label>
                                    <i class="fa fa-question-circle info-question-circle">
                                        <div class="custom-popover-wrapper">
                                            <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Register_number_info')"></div>
                                        </div>
                                    </i>
                                </div>
                            </div>

                            <div v-if="$store.state.registrationNumberSelected">
                                <input type="text" style="max-width: 508px;" v-model="$store.state.otherDeliveryInformation.registrationNumber" :placeholder="$helper.trans('Register_number')" class="input-big mt-2 w-100">
                            </div>
                        </div>

                        <div class="packet-row packet-column packet-line" v-if="$store.state.otherDeliveryInformation.cashOnDelivery">
                            <label class="strong-label label-margin">{{ $helper.trans('Cash_on_delivery') }}:</label>
                            <div class="option-content option-content-row">
                                <div class="option-column">
                                    <input type="text" v-model="$store.state.otherDeliveryInformation.cashAmount" :placeholder="$helper.trans('Cash_amount')" class="input-big otherDeliveryInformation_cashAmount_input">
                                </div>
                                <div class="option-column">
                                    <select2-component :values="{ '': '', 'EUR': 'EUR', 'USD': 'USD' }" :placeholder="$helper.trans('Currency')" :noLang="true" classes="input-big select-single select-style-ups otherDeliveryInformation_cashCurrency_input" v-model="$store.state.otherDeliveryInformation.cashCurrency"></select2-component>
                                </div>
                            </div>
                        </div>

                        <div class="packet-row packet-column packet-line" v-if="$store.state.otherDeliveryInformation.notifications">
                            <label class="strong-label label-margin">{{ $helper.trans('El_messages') }}:</label>
                            <div class="w-100">
                                <table class="table">
                                    <tr>
                                        <td style="width: 55%">{{ $helper.trans('Notification_about') }}:</td>
                                        <td style="width: auto">{{ $helper.trans('About_parcel') }}</td>
                                        <td style="width: auto" v-if="isImport && !areBothLt">{{ $helper.trans('Package_pickup') }}</td>
                                        <td style="width: auto">{{ $helper.trans('About_exceptions') }}</td>
                                        <td style="width: auto">{{ $helper.trans('About_parcel_delivery') }}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input type="email" class="input-big" v-model="$store.state.shipperAddressInformation.email" :placeholder="$helper.trans('Please_type_email')">
                                            <div class="notifications_senderEmail_input"></div>
                                        </td>
                                        <td>
                                            <label for="op-7" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-7" v-model="$store.state.otherDeliveryInformation.senderAboutParcelEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td v-if="isImport && !areBothLt">
                                            <label for="op-20" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-20" v-model="$store.state.otherDeliveryInformation.senderAboutPackagePickupEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td>
                                            <label for="op-8" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-8" v-model="$store.state.otherDeliveryInformation.senderAboutExceptionsEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td>
                                            <label for="op-9" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-9" v-model="$store.state.otherDeliveryInformation.senderAboutParcelDeliveryEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input type="email" class="input-big" v-model="$store.state.deliveryAddressInformation.email" :placeholder="$helper.trans('Please_type_email')">
                                            <div class="notifications_receiverEmail_input"></div>
                                        </td>
                                        <td>
                                            <label for="op-10" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-10" v-model="$store.state.otherDeliveryInformation.receiverAboutParcelEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td v-if="isImport && !areBothLt">
                                            <label for="op-21" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-21" v-model="$store.state.otherDeliveryInformation.receiverAboutPackagePickupEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td>
                                            <label for="op-11" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-11" v-model="$store.state.otherDeliveryInformation.receiverAboutExceptionsEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td>
                                            <label for="op-12" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-12" v-model="$store.state.otherDeliveryInformation.receiverAboutParcelDeliveryEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input type="email" class="input-big" v-model="$store.state.otherDeliveryInformation.otherNotificationsEmail" :placeholder="$helper.trans('Please_type_email')">
                                            <div class="notifications_otherEmail_input"></div>
                                        </td>
                                        <td>
                                            <label for="op-17" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-17" v-model="$store.state.otherDeliveryInformation.otherAboutParcelEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td v-if="isImport && !areBothLt">
                                            <label for="op-22" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-22" v-model="$store.state.otherDeliveryInformation.otherAboutPackagePickupEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td>
                                            <label for="op-18" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-18" v-model="$store.state.otherDeliveryInformation.otherAboutExceptionsEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td>
                                            <label for="op-19" class="custom-checkbox-wrap">
                                                <input type="checkbox" id="op-19" v-model="$store.state.otherDeliveryInformation.otherAboutParcelDeliveryEmail">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="packet-row packet-column packet-option" v-show="$store.state.selectedFormType === 'single' && needsCommercialInvoice">
                        <label class="strong-label">
                            {{ $helper.trans('Commercial_invoice') }}:
                            <i class="fa fa-question-circle info-question-circle">
                                <div class="custom-popover-wrapper">
                                    <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Commercial_invoice_info')"></div>
                                </div>
                            </i>
                        </label>
                        <div class="option-content">
                            <i 
                                class="fa fa-pencil mr-2" 
                                v-show="$store.state.copied && $store.state.otherDeliveryInformation.commercialInvoiceType == 'fill'" 
                                @click="editCommercialInvoiceModal();"
                                style="cursor:pointer;"
                            ></i>
                            <label for="invoice-1" class="custom-radio-wrap">
                                {{ $helper.trans('Fill_out_commercial_invoice') }}                                
                                <input type="radio" @click="clickCommercialRadio('fill');" v-model="$store.state.otherDeliveryInformation.commercialInvoiceType" value="fill" id="invoice-1" class="commercialInvoiceModal_radio_input otherDeliveryInformation_commercialInvoiceType_input">
                                <span class="checkmark"></span>
                            </label>                            
                            <label for="invoice-2" class="custom-radio-wrap" v-show="$store.state.transportationType !== 'import'">
                                {{ $helper.trans('Add_commercial_invoice') }}
                                <input type="radio" @click="clickCommercialRadio('attach');" v-model="$store.state.otherDeliveryInformation.commercialInvoiceType" value="attach" id="invoice-2">
                                <span class="checkmark"></span>
                            </label>
                            <label for="invoice-3" class="custom-radio-wrap" v-if="$store.state.$siteSettings['no_commercial_invoice_needed']">
                                {{ $helper.trans('Add_commercial_invoice_to_shipment') }}
                                <input type="radio" @click="clickCommercialRadio('with_shipment');" v-model="$store.state.otherDeliveryInformation.commercialInvoiceType" value="with_shipment" id="invoice-3">
                                <span class="checkmark"></span>
                            </label>

                            <div class="alert alert-warning" v-show="$store.state.otherDeliveryInformation.commercialInvoiceType === 'with_shipment'">
                                {{ $helper.trans('Commercial_invoice_with_shipment_remark') }}
                            </div>                            

                            <div class="option-content option-content-row w-100 commercialInvoice" v-show="$store.state.otherDeliveryInformation.commercialInvoiceType === 'attach' && $store.state.transportationType !== 'import'">
                                <div class="option-column custom-focus invoiceTotal">
                                    <label class="input-label w-100">
                                        <input type="number" v-model="$store.state.otherDeliveryInformation.invoiceTotal" class="input-big js_form-input commercialInvoice_invoiceTotal_input" onblur="checkOnBlur(this)" @change="checkCommercialInvoicePrice()">
                                        <span class="label-span">{{ $helper.trans('Total_sum') }}</span>
                                    </label>
                                </div>
                                <div class="option-column invoiceCurrency">
                                    <select2-component :values="currencies" :placeholder="$helper.trans('Currency')" :noLang="true" classes="input-big select-single select-style-ups commercialInvoice_invoiceCurrency_input" v-model="$store.state.otherDeliveryInformation.invoiceCurrency"></select2-component>
                                </div>
                            </div>

                            <span
                                v-if="$store.state.packageValue50k"
                                class="d-block"
                                style="color: red;font-weight: 700;font-size: 15px;"
                                v-html="$helper.trans('Package_value_50k')" 
                            ></span>
                                                 
                            <span 
                                v-if="$store.state.to.country === 'gb' && $store.state.selectedShippingOption.serviceCode === '11' && $store.state.otherDeliveryInformation.commercialInvoiceType === 'attach'" 
                                class="d-block"
                                style="color: #b35c00;font-weight: 700;font-size: 15px;"
                                v-html="$helper.trans('Hs_code_required')"                            
                            ></span>    
                            
                            <div class="option-content full-width option-upload-content" v-show="$store.state.otherDeliveryInformation.commercialInvoiceType === 'attach' && $store.state.transportationType !== 'import'">
                                <div class="w-100 upload-style uploadedFiles_commercialInvoiceAttachments_input">
                                    <div class="form-file">
                                        <div id="commercial_invoice_attachment_dropzone" class="my-dropzone upload-field">
                                            <div class="dropzone-panel mb-lg-0 mb-2">
                                                <span class="icon-upload"></span>
                                                <span class="title-upload">{{ $helper.trans('Upload_files_here') }}</span>
                                                <span class="or">{{ $helper.trans('Or') }}</span>
                                                <label class="btn btn-upload dropzone-select">{{ $helper.trans('Select_from_device') }}</label>
                                            </div>

                                            <div class="dropzone-items wm-200px"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span class="font-weight-bold text-danger" v-if="$store.state.otherDeliveryInformation.commercialInvoiceType !== 'fill' && $store.state.transportationType === 'import'" v-html="$helper.trans('Import_no_commercial_invoice_message')"></span>
                    </div>
                    <div class="packet-row packet-column packet-option" v-show="$store.state.selectedFormType === 'mass' && needsCommercialInvoice">
                        <label class="strong-label">
                            {{ $helper.trans('Commercial_invoice') }}:
                            <i class="fa fa-question-circle info-question-circle">
                                <div class="custom-popover-wrapper">
                                    <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Commercial_invoice_info')"></div>
                                </div>
                            </i>
                        </label>
                        <div class="col-12 mt-2" v-show="filteredMassShipments">
                            <div class="custom-table">
                                <div class="table-wrap">
                                    <div class="table-head">
                                        <div class="table-tr" style="padding: 15px 0 15px 15px;">
                                            <div class="table-td" style="width:20%;">{{ $helper.trans('Address') }}</div>
                                            <div class="table-td" style="width:10%;">{{ $helper.trans('City') }}</div>
                                            <div class="table-td" style="width:10%;">{{ $helper.trans('Zip_code') }}</div>
                                            <div class="table-td" style="width:10%;">{{ $helper.trans('Country') }}</div>
                                            <div class="table-td" style="width:15%;">{{ $helper.trans('Service') }}</div>
                                            <div class="table-td" style="width:30%;">{{ $helper.trans('Latest_collection_time') }}</div>
                                            <div class="table-td" style="width:30%;">{{ $helper.trans('Estimated_delivery') }}</div>
                                            <div class="table-td" style="width:12%;">
                                                {{ $helper.trans('With_warranty') }}
                                                <i class="fa fa-question-circle info-question-circle position-absolute" style="margin-top: -5;">
                                                    <div class="custom-popover-wrapper">
                                                        <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Guaranteed_indicator_info')">
                                                        </div>
                                                    </div>
                                                </i>
                                            </div>
                                            <div class="table-td" style="width:10%;">{{ $helper.trans('Price') }}</div>
                                        </div>
                                    </div>
                                    <div class="mb-3" v-if="filteredMassShipments">
                                        <div v-for="(shipment, index) in filteredMassShipments" :key="index" 
                                            class="table-tr shipment-details-block" :class="{ 'openBlock': shipment.show }">                   
                                            <div 
                                                class="table-tr-content shipment-details-header mass-shipments-table" 
                                                :class="`block_${index}`"
                                            >
                                                <div class="table-td" style="width:20%;">{{ shipment.Address1 }}</div>
                                                <div class="table-td" style="width:10%;">{{ shipment.City }}</div>
                                                <div class="table-td" style="width:10%;">{{ shipment.PostCode }}</div>
                                                <div class="table-td" style="width:10%;">{{ countries[shipment.Country] }}</div>
                                                <div class="table-td" style="width:15%;">{{ shipment.service.serviceName }}</div>
                                                <div class="table-td" style="width:30%;">
                                                    <span class="price-delivery-date" style="text-transform:capitalize;" v-html="$helper.formattedEstimatedPickup(shipment.service)"></span>
                                                </div>
                                                <div class="table-td" style="width:30%;">
                                                    <span class="price-delivery-date" v-html="$helper.formattedEstimatedDelivery(shipment.service)"></span>
                                                </div> 
                                                <div class="table-td" style="width:12%;">
                                                    {{ $helper.getGuaranteed(shipment.service.guaranteed) }}
                                                </div>
                                                <div class="table-td" style="width:10%;">
                                                    {{ $helper.getPrice(shipment.service.total_without_vat) }}
                                                </div>
                                            </div>
                                            <div class="toggle-wrap" :class="`block_${index}_input`" style="display:block;">
                                                <div class="toggle-content" style="padding-bottom: 0;">
                                                    <div class="option-content">
                                                        <label :for="'commercial-invoice1-' + index" class="custom-radio-wrap">
                                                            {{ $helper.trans('Fill_out_commercial_invoice') }}
                                                            <input
                                                                type="radio"
                                                                @click="clickMassShipmentCommercialRadio('fill', shipment);openCommercialInvoiceModal(index);"
                                                                v-model="shipment.otherDeliveryInformation.commercialInvoiceType"
                                                                value="fill"
                                                                :id="'commercial-invoice1-' + index"
                                                                :class="'massShipments_' + index + '_requiredCommercialInvoice_input'"   
                                                            >
                                                            <span class="checkmark"></span>
                                                        </label>
                                                        <label :for="'commercial-invoice2-' + index" class="custom-radio-wrap">
                                                            {{ $helper.trans('Add_commercial_invoice') }}
                                                            <input 
                                                                type="radio" 
                                                                @click="clickMassShipmentCommercialRadio('attach', shipment);" 
                                                                v-model="shipment.otherDeliveryInformation.commercialInvoiceType" 
                                                                value="attach" 
                                                                :id="'commercial-invoice2-' + index"
                                                            >
                                                            <span class="checkmark"></span>
                                                        </label>
                                                        <label :for="'commercial-invoice3-' + index" 
                                                            class="custom-radio-wrap" 
                                                            v-if="$store.state.$siteSettings['no_commercial_invoice_needed']"
                                                        >
                                                            {{ $helper.trans('Add_commercial_invoice_to_shipment') }}
                                                            <input 
                                                                type="radio" 
                                                                @click="clickMassShipmentCommercialRadio('with_shipment', shipment);" 
                                                                v-model="shipment.otherDeliveryInformation.commercialInvoiceType"
                                                                value="with_shipment" 
                                                                :id="'commercial-invoice3-' + index"
                                                            >
                                                            <span class="checkmark"></span>
                                                        </label>
                                                        <div class="option-content option-content-row w-100 commercialInvoice" 
                                                            v-show="shipment.otherDeliveryInformation.commercialInvoiceType === 'attach'">
                                                            <div class="option-column custom-focus invoiceTotal">
                                                                <label class="input-label w-100">
                                                                    <input type="number" v-model="shipment.otherDeliveryInformation.invoiceTotal" class="input-big js_form-input commercialInvoice_invoiceTotal_input" onblur="checkOnBlur(this)">
                                                                    <span class="label-span">{{ $helper.trans('Total_sum') }}</span>
                                                                </label>
                                                            </div>
                                                            <div class="option-column invoiceCurrency">
                                                                <select2-component 
                                                                    :values="currencies" 
                                                                    :placeholder="$helper.trans('Currency')" 
                                                                    :noLang="true" 
                                                                    classes="input-big select-single select-style-ups commercialInvoice_invoiceCurrency_input" 
                                                                    v-model="shipment.otherDeliveryInformation.invoiceCurrency">
                                                                </select2-component>
                                                            </div>
                                                        </div>                                                        
                                                        <span 
                                                            v-if="shipment.Country === 'gb' && shipment.ServiceCode === '11' && shipment.otherDeliveryInformation.commercialInvoiceType === 'attach'" 
                                                            class="d-block ciaciaicai"
                                                            style="color: #b35c00;font-weight: 700;font-size: 15px;"
                                                            v-html="$helper.trans('Hs_code_required')"                            
                                                        ></span>  
                                                        <div class="option-content full-width option-upload-content" 
                                                            v-show="shipment.otherDeliveryInformation.commercialInvoiceType === 'attach'"
                                                        >  
                                                            <div class="w-100 upload-style uploadedFiles_commercialInvoiceAttachments_input">
                                                                <div class="form-file">
                                                                    <div :id="'commercial_invoice_attachment_dropzone_'+index" class="my-dropzone upload-field">
                                                                        <div class="dropzone-panel mb-lg-0 mb-2">
                                                                            <span class="icon-upload"></span>
                                                                            <span class="title-upload">{{ $helper.trans('Upload_files_here') }}</span>
                                                                            <span class="or">{{ $helper.trans('Or') }}</span>
                                                                            <label class="btn btn-upload dropzone-select">{{ $helper.trans('Select_from_device') }}</label>
                                                                        </div>
                                                                        <div class="dropzone-items wm-200px"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>                                 
                                                </div>
                                            </div> 
                                        </div>                                     
                                    </div> 
                                </div>
                            </div>                        
                        </div> 
                    </div>
                    <div class="packet-row packet-column packet-option" v-show="$store.state.to.country === 'no'">
                        <label class="strong-label justify-content-between" style="max-width: 38%;">
                            <span>
                                {{ $helper.trans('Voec_vat_registration') }}:
                                <i class="fa fa-question-circle info-question-circle">
                                    <div class="custom-popover-wrapper">
                                        <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Voec_vat_registration_info')"></div>
                                    </div>
                                </i>
                            </span>
                            <span style="color: #3c83ce;font-size: 12px;font-weight: 100;">                                 
                                <i class="fa fa-question-circle info-question-circle">
                                    {{ $helper.trans('Help') }}
                                    <div class="custom-popover-wrapper">
                                        <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Voec_vat_registration_description')"></div>
                                    </div>
                                </i>
                            </span>
                        </label>
                        <div class="option-content">
                            <div class="option-content option-content-row w-100 otherDeliveryInformation_voecVatRegistration_input">          
                                <div class="option-column">
                                    <input type="text" v-model="$store.state.otherDeliveryInformation.voecVatRegistration" class="input-big js_form-input" :placeholder="$helper.trans('Voec_number')">                                  
                                </div>    
                            </div>
                        </div>                       
                    </div>
                    <div class="packet-row packet-column packet-option" v-show="$store.state.to.country === 'gb'">
                        <label class="strong-label">
                            {{ $helper.trans('Pva_registration') }}:
                            <i class="fa fa-question-circle info-question-circle">
                                <div class="custom-popover-wrapper">
                                    <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Pva_registration_info')"></div>
                                </div>
                            </i>
                        </label>
                        <div class="option-content">
                            <div class="option-content option-content-row w-100 otherDeliveryInformation_pvaRegistration_input">
                                <div class="option-column">
                                    <input type="text" v-model="$store.state.otherDeliveryInformation.pvaRegistration" class="input-big js_form-input" :placeholder="$helper.trans('Pva_number')">
                                </div>                               
                            </div>
                        </div>                       
                    </div>
                    <div v-if="$store.state.$siteSettings['Logged_in']" class="packet-row packet-checkbox" v-show="$store.state.to.country === 'gb' || $store.state.to.country === 'no'">
                        <label for="ch-5" class="custom-checkbox-wrap">
                            {{ $helper.trans('Save_this_number') }}
                            <input type="checkbox" v-model="$store.state.otherDeliveryInformation.saveVoecOrPvaCode" id="ch-5">
                            <span class="checkmark"></span>
                        </label>                       
                    </div>
                    <div class="link-block w-100" v-if="$store.state.inClientAdmin">
                        <button type="button" @click="nextStep(4, true);" class="link link-left">{{ $helper.trans('Shipping_option_selection') }}</button>
                        <button type="button" @click="nextStep(6)" class="link link-right">{{ ($store.state.transportationType === 'export') ? $helper.trans('Courier_call') : $helper.trans('Label_presenting') }}</button>
                    </div>
                    <div class="link-block w-100" v-else>
                        <button type="button" @click="nextStep(2, true);" class="link link-left">{{ $helper.trans('Receiving_address') }}</button>
                        <button type="button" @click="nextStep(4)" class="link link-right">{{ ($store.state.transportationType === 'export') ? $helper.trans('Courier_call') : $helper.trans('Label_presenting') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function () {
        return {
            dropzone: undefined,
            editClicks: 0,
            editTimer: null,
            quickEdit: false,
            quickEditBtn: false,
            errorMessage: false,
            previousDimensions: undefined,
            countries: {}, 
            filesCount: [],
            totalFileSize: 0,
            maxTotalSize: 10 * 1024 * 1024,
        };

    },
    created: function () {
        let vueThis = this;

        $.each(this.$store.state.countriesList, function (index, element) {
            vueThis.countries[element.country_code.toLowerCase()] = element.title;
        });
        
        vueThis.previousDimensions = structuredClone(vueThis.$store.state.packagesDimensions);       

        vueThis.$nextTick(function () {
            let template = `<div class="dropzone-item"><div class="dropzone-file"><div class="dropzone-filename" title="some_image_file_name.jpg"><span data-dz-name>some_image_file_name.jpg</span><strong>(<span data-dz-size>340kb</span>)</strong></div><div class="dropzone-error" data-dz-errormessage></div></div><div class="dropzone-progress"><div class="progress"><div class="progress-bar bg-primary" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" data-dz-uploadprogress></div></div></div><div class="dropzone-toolbar"><span class="dropzone-delete" data-dz-remove><i class="bi bi-x fs-1"></i></span></div></div>`;

            vueThis.dropzone = new window.Dropzone('#commercial_invoice_attachment_dropzone', {
                url: vueThis.$store.state.$routes['upload_files.store'],
                headers: {
                    'x-csrf-token': $('meta[name="csrf-token"]').attr('content')
                },
                init: function () {
                    this.on('success', function (file, response) {
                        $(file.previewElement).data('file-id', response);
                        vueThis.$store.state.uploadedFiles.commercialInvoiceAttachments.push(response);
                    });
                },
                previewTemplate: template,
                previewsContainer: '#commercial_invoice_attachment_dropzone .dropzone-items',
                clickable: '#commercial_invoice_attachment_dropzone .dropzone-select',
                addRemoveLinks: true,
                removedfile: function (file) {
                    let itemIndex = vueThis.$store.state.uploadedFiles.commercialInvoiceAttachments.indexOf($(file.previewElement).data('file-id'));
                    if (itemIndex !== -1) {
                        vueThis.$store.state.uploadedFiles.commercialInvoiceAttachments.splice(itemIndex, 1);
                    }
                    $(file.previewElement).remove();
                    vueThis.totalFileSize -= parseInt(file.size);
                    vueThis.filesCount.splice(0, 1);
                },           
                accept: function (file, done) {
                    let extension = vueThis.getFileExtensionFromMimeType(file.type);
                    vueThis.filesCount.push(file.name);
                    let sizeOk = true;
              
                    if (parseInt(vueThis.totalFileSize) + parseInt(file.size) > parseInt(vueThis.maxTotalSize)) {    
                        sizeOk = false;    
                        done(vueThis.$helper.trans('The_total_size_of_all_files_should_not_exceed_10_mb'));
                    } 

                    vueThis.totalFileSize += parseInt(file.size);

                    if (sizeOk) {
                        if (vueThis.filesCount.length > 1) {
                            if (extension === 'pdf') {
                                done();
                            } else {
                                done(vueThis.$helper.trans('Only_pdf_files_are_allowed_when_uploading_multiple_files'));
                            }
                        } else {              
                            if (['bmp', 'doc', 'gif', 'jpg', 'jpeg', 'pdf', 'png', 'rtf', 'tif', 'txt', 'xls', 'docx', 'xlsx'].includes(extension)) {
                                done();
                            } else {
                                done(vueThis.$helper.trans('Invalid_file_type'));
                            }
                        }
                    }             
                },
                maxFiles: 5,
            });

            vueThis.dropzone.on('totaluploadprogress', function (progress) {
                $('#commercial_invoice_attachment_dropzone').find('.progress-bar').each(function (index, element) {
                    $(element).css({ 'width': `${progress}%` });
                });
            });
            
            vueThis.dropzone.on('error', function (file, message) {
                if (!file.accepted) {
                    this.removeFile(file); // Manually remove the file from the dropzone if it was rejected
                }
                alert(message); // Optionally, alert the error message
            });
        });        
    },
    methods: {
        selectShippingBackGroundOption: function(shippingOption, stay=false) {
            this.$store.state.selectedShippingOption = shippingOption;
            this.$store.state.checkOutSteps.second = false; 

            if (moment(shippingOption.estimatedDelivery).weekday() == 6 && this.$store.state.selectedShippingOption.isSaturdayDeliveryAvailable) {
                this.$store.state.otherDeliveryInformation.saturdayDelivery = true;
            }   

            if (stay) {
                return;
            }
            
            if (!this.$store.state.checkOutSteps.second) {                              
                this.$helper.pushDataLayer(2, shippingOption);  
                this.$store.state.checkOutSteps.second = true;
            }

            if (this.isEdit) {
                this.$store.state.currentActions.editingPackages = false;
                return;
            } else {
                this.$emit('optionSelected');
            }
        },
        getSearchBackGroundOptions: async function() {
            let vueThis = this;           

            // NOTE Set Malta city
            if (vueThis.$store.state.from.country === 'mt') {
                vueThis.$store.state.shipperAddressInformation.city = vueThis.$helper.getMaltaCity(vueThis.$store.state.from.postCode);
            }
            if (vueThis.$store.state.to.country === 'mt') {
                vueThis.$store.state.deliveryAddressInformation.city = vueThis.$helper.getMaltaCity(vueThis.$store.state.to.postCode);
            }

            if (!vueThis.$store.state.inClientAdmin) {
                if (vueThis.$store.state.from.country === 'ma') {
                    vueThis.$store.state.from.postCode = vueThis.$helper.getMoroccoPostCode(vueThis.$store.state.shipperAddressInformation.city);
                }
                if (vueThis.$store.state.to.country === 'ma') {
                    vueThis.$store.state.to.postCode = vueThis.$helper.getMoroccoPostCode(vueThis.$store.state.deliveryAddressInformation.city);
                }
            }

            let customDiscounts = [];

            let url = vueThis.$store.state.$routes['api.get_shipping_options_json'];
            let data = {
                from: {
                    country: vueThis.$store.state.from.country,
                    postCode: vueThis.$store.state.from.postCode,
                    city: vueThis.$store.state.shipperAddressInformation.city,
                },
                to: {
                    country: vueThis.$store.state.to.country,
                    postCode: vueThis.$store.state.to.postCode,
                    city: vueThis.$store.state.deliveryAddressInformation.city,
                },
                clientId: vueThis.customCalculator ? vueThis.$store.state.clientId : null,
                customDiscounts,
                packageType: vueThis.$store.state.packageType,
                packages: vueThis.$store.state.packagesDimensions
            };       
    
            await axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(function(response) {
                vueThis.currentError = response.data.error;
                vueThis.$store.state.availableShippingOptions = response.data.rates;

                if (vueThis.customCalculator) {
                    vueThis.$store.state.temporaryDetailedCosts = response.data.detailed_costs;
                }

                if (!empty(vueThis.$store.state.userSettings.default_main_service) && !vueThis.$store.state.copied) {
                    $.each(vueThis.$store.state.availableShippingOptions, function (index, option) {
                        if (option.serviceCode === vueThis.$store.state.userSettings.default_main_service) {
                            vueThis.selectShippingBackGroundOption(option, true);
                            return false;
                        }
                    });
                }
      
                vueThis.$store.state.availableShippingOptions = response.data.rates;
                vueThis.$store.state.additionalAddressInfo = response.data.additionalAddressInfo;
     
                if (vueThis.$store.state.additionalAddressInfo.from !== undefined && vueThis.$store.state.additionalAddressInfo.from.length > 0) {
                    if (vueThis.$store.state.additionalAddressInfo.from.length === 1) {
                        vueThis.$store.state.shipperAddressInformation.city = vueThis.$store.state.additionalAddressInfo.from[0].city;
                    }
                    vueThis.$store.state.shipperAddressInformation.stateOrProvince = vueThis.$store.state.additionalAddressInfo.from[0].state.toLowerCase();
                    vueThis.$store.state.awaitingActions.refreshStateOrProvince.shipperAddressInformation = true;
                }
                if (vueThis.$store.state.additionalAddressInfo.to !== undefined && vueThis.$store.state.additionalAddressInfo.to.length > 0) {
                    if (vueThis.$store.state.additionalAddressInfo.to.length === 1) {
                        vueThis.$store.state.deliveryAddressInformation.city = vueThis.$store.state.additionalAddressInfo.to[0].city;
                    }
                    vueThis.$store.state.deliveryAddressInformation.stateOrProvince = vueThis.$store.state.additionalAddressInfo.to[0].state.toLowerCase();
                    vueThis.$store.state.awaitingActions.refreshStateOrProvince.deliveryAddressInformation = true;
                }
            }).catch(function(error) {
                if (error.response.status == 422) {
                    console.table(error.response.data.errors);
                    alert('Formoje yra klaidų');
                }
            }).finally(function() {   
                vueThis.$store.state.currentActions.gettingShippingOptions = false;
            });
        },
        editCommercialInvoiceModal() {
            $('#commercial_invoice_modal').modal('show');
        },
        getFileExtensionFromMimeType(fileType) {
            let acceptableFileTypes = {
                'image/jpg': 'jpg',
                'image/jpeg': 'jpeg',
                'image/png': 'png',
                'application/pdf': 'pdf',
                'application/msword': 'doc',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
            }
           
            for (const mimeTypePattern in acceptableFileTypes) {
                if (fileType.startsWith(mimeTypePattern)) {
                    return acceptableFileTypes[mimeTypePattern];
                }
            }
            return null;
        },

        assignCommercialInvoiceUploadAreas() {
            let vueThis = this;                

            $.each(vueThis.filteredMassShipments, function (index, shipment) {
                let filesCount = [];
                let totalFileSize = 0;

                vueThis.$nextTick(function () {
                    let template = `<div class="dropzone-item"><div class="dropzone-file"><div class="dropzone-filename" title="some_image_file_name.jpg"><span data-dz-name>some_image_file_name.jpg</span><strong>(<span data-dz-size>340kb</span>)</strong></div><div class="dropzone-error" data-dz-errormessage></div></div><div class="dropzone-progress"><div class="progress"><div class="progress-bar bg-primary" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" data-dz-uploadprogress></div></div></div><div class="dropzone-toolbar"><span class="dropzone-delete" data-dz-remove><i class="bi bi-x fs-1"></i></span></div></div>`;
                    vueThis.dropzone = new window.Dropzone(`#commercial_invoice_attachment_dropzone_${index}`, {
                        url: vueThis.$store.state.$routes['upload_files.store'],
                        headers: {
                            'x-csrf-token': $('meta[name="csrf-token"]').attr('content')
                        },
                        init: function () {
                            this.on('success', function (file, response) {
                                $(file.previewElement).data('file-id', response);
                                shipment.uploadedFiles.commercialInvoiceAttachments.push(response);
                            });
                        },
                        previewTemplate: template,
                        previewsContainer: `#commercial_invoice_attachment_dropzone_${index} .dropzone-items`,
                        clickable: `#commercial_invoice_attachment_dropzone_${index} .dropzone-select`,
                        addRemoveLinks: true,
                        removedfile: function (file) {
                            let itemIndex = shipment.uploadedFiles.commercialInvoiceAttachments.indexOf($(file.previewElement).data('file-id'));
                            if (itemIndex !== -1) {
                                shipment.uploadedFiles.commercialInvoiceAttachments.splice(itemIndex, 1);
                            }
                            $(file.previewElement).remove();
                            totalFileSize -= parseInt(file.size);
                            filesCount.splice(0, 1);
                        },
                        accept: function (file, done) {
                            let extension = vueThis.getFileExtensionFromMimeType(file.type);
                            filesCount.push(file.name);                                        
                            let sizeOk = true;
              
                            if (parseInt(totalFileSize) + parseInt(file.size) > parseInt(vueThis.maxTotalSize)) {    
                                sizeOk = false;    
                                done(vueThis.$helper.trans('The_total_size_of_all_files_should_not_exceed_10_mb'));
                            } 
                                
                            totalFileSize += parseInt(file.size);
                          
                            if (sizeOk) {
                                if (filesCount.length > 1) {
                                    if (extension === 'pdf') {
                                        done();
                                    } else {
                                        done(vueThis.$helper.trans('Only_pdf_files_are_allowed_when_uploading_multiple_files'));
                                    }
                                } else {              
                                    if (['bmp', 'doc', 'gif', 'jpg', 'jpeg', 'pdf', 'png', 'rtf', 'tif', 'txt', 'xls', 'docx', 'xlsx'].includes(extension)) {
                                        done();
                                    } else {
                                        done(vueThis.$helper.trans('Invalid_file_type'));
                                    }
                                }
                            }             
                        },
                        maxFiles: 5,
                    });

                    vueThis.dropzone.on('totaluploadprogress', function (progress) {
                        $(`#commercial_invoice_attachment_dropzone_${index}`).find('.progress-bar').each(function (index, element) {
                            $(element).css({ 'width': `${progress}%` });
                        });
                    });
                });
            });
        },
        openCommercialInvoiceModal: function(index) {
            $('.commercialInvoiceBlock').hide();
            $(`.commercialInvoiceBlock_${index}`).show();
            $('#commercial_invoice_modal').modal('show');
        },
        clickMassShipmentCommercialRadio: function (type, shipment) {
            if (shipment.commercialInvoiceType === type) {
                shipment.commercialInvoiceType = '';
            }

            this.$forceUpdate();
        },
        clickCommercialRadio: function (type) {
            if (this.$store.state.otherDeliveryInformation.commercialInvoiceType === type) {
                this.$store.state.otherDeliveryInformation.commercialInvoiceType = '';
            }
            this.$forceUpdate();
        },
        openPackageEdit: function() {
            this.$store.state.currentActions.editingPackages = true;
            $('.weight').first().focus();
        },
        toggleEdit: function (type) {
            let vueThis = this;
            vueThis.editClicks++;
            if (vueThis.editClicks === 1) {
                vueThis.editTimer = setTimeout(function () {
                    vueThis.$store.state.quickEditDimensions = type;
                    vueThis.$forceUpdate();
                    vueThis.editClicks = 0
                    vueThis.$nextTick(function () {
                        $('.edit-dimensions-width').first().focus();
                    });
                }, 300);

            } else {
                clearTimeout(vueThis.editTimer);
                vueThis.openPackageEdit();
                vueThis.editClicks = 0;
            }
        },
        checkCommercialInvoicePrice: async function() {
            let vueThis = this;  
            let url = vueThis.$store.state.$routes['api.check_commercial_invoice_price_json'];
            let invoiceCurrency = vueThis.$store.state.otherDeliveryInformation.invoiceCurrency;

            let data = {
                'otherDeliveryInformation': {
                    'commercialInvoiceType' : vueThis.$store.state.otherDeliveryInformation.commercialInvoiceType
                },
                'commercialInvoice': {
                    'invoiceCurrency': invoiceCurrency === 'usd' ? 'eur' : 'usd',
                    'invoiceTotal': vueThis.$store.state.otherDeliveryInformation.invoiceTotal
                }
            };
      
            try {
                const response = await axios.post(url, data);                  
                    if (response.data.amount > 50000) {
                        vueThis.$store.state.packageValue50k = true;
                    } else {
                        vueThis.$store.state.packageValue50k = false;
                    }           
            } catch (error) {
                console.log(error);
            }

        },
        validatePackageValue: function (index, type) {
            let vueThis = this;
            let currentValue = vueThis.$store.state.packagesDimensions[index][type];

            vueThis.quickEditBtn = true;
            vueThis.errorMessage = false;
            let sortedSizes = [
                parseInt(vueThis.$store.state.packagesDimensions[index].width),
                parseInt(vueThis.$store.state.packagesDimensions[index].length),
                parseInt(vueThis.$store.state.packagesDimensions[index].height)
            ].sort(function (a, b) { return a - b }).reverse();

            if ((sortedSizes[0] + sortedSizes[1] * 2 + sortedSizes[2] * 2) > 400) {
                vueThis.$store.state.packagesDimensions[index] = structuredClone(vueThis.previousDimensions[index]);
                vueThis.errorMessage = vueThis.$helper.trans('General_dimensions_error')

            } else {

                if (!currentValue || isNaN(currentValue)) {
                    currentValue = 0;
                }
                if (type === 'weight') {
                    currentValue = parseFloat(currentValue);
                    if (currentValue < 0.1) {
                        currentValue = 0.1;
                    }
                    if (currentValue > 70) {
                        currentValue = 70;
                        vueThis.errorMessage = vueThis.$helper.trans('Overweight')
                    }

                    currentValue = Math.round(currentValue * 100) / 100;
                } else {
                    currentValue = parseInt(currentValue);
                    if (currentValue < 1) {
                        currentValue = 1;
                    }
                    if (currentValue > 270) {
                        currentValue = 270;
                        vueThis.errorMessage = vueThis.$helper.trans('Dimension_too_large')
                    }
                }

                vueThis.previousDimensions = structuredClone(vueThis.$store.state.packagesDimensions);
                vueThis.$store.state.packagesDimensions[index][type] = currentValue;

            }
            vueThis.$forceUpdate();
        },
        recalculate: function () {
            this.quickEdit = true;
            this.quickEditBtn = false;
            this.$store.state.currentActions.gettingShippingOptions = true;
            this.$store.state.awaitingActions.getSearchOptions = true;
        },
        checkSignatureRule() {
            $('.otherDeliveryInformation_requireSignature_input, .otherDeliveryInformation_adultSignature_input').removeClass('alert-danger-ups').parent().removeClass('custom-ups-error-parent').find('.ups-danger-text').remove();
            if (this.$store.state.otherDeliveryInformation.requireSignature && this.$store.state.otherDeliveryInformation.adultSignature) {
                $('.otherDeliveryInformation_requireSignature_input, .otherDeliveryInformation_adultSignature_input').addClass('alert-danger-ups').parent().addClass('custom-ups-error-parent').append(`<span class="ups-danger-text ml-3">${this.$helper.trans('One_signature_error')}</span>`);
            }
        },
        nextStep(nextStep, validate=false) {
            if (this.$store.state.selectedFormType === 'mass' && nextStep === 4) {
                nextStep = 2;
            } 

            if (nextStep === 6) {
                validate = true;
            } 

           this.$helper.toggleAccordion(nextStep, validate); 
        },
    },
    computed: {
        filteredMassShipments() {
            let vueThis = this;
            let northernIrelandRegex = /^BT/i;

            let massShipments = {};
            $.each(vueThis.$store.state.massShipments, function (index, element) {
                let add = false;
                if (element.Country === 'gb' && northernIrelandRegex.test(element.PostCode)) {
                    add = true;               
                }
        
                if (element.Country === 'mc') {
                    add = true;                 
                }
        
                if (!vueThis.$helper.checkNotEu(element.Country)) {
                    add = true;                   
                }

                if (add) {
                    massShipments[index] = element;
                }
            });              
        
            return massShipments;
        },
        packageType() {
            let map = {
                '01': this.$helper.trans('Envelope'),
                '02': this.$helper.trans('Box'),
                '04': this.$helper.trans('UPS_Package'),
            };
            return map[this.$store.state.packageType] || '';
        },
        fullShipperAddress() {
            let address = this.$store.state.shipperAddressInformation.address1;
            if (this.$store.state.shipperAddressInformation.address2 !== '') {
                address += ' ' + this.$store.state.shipperAddressInformation.address2;
            }
            if (this.$store.state.shipperAddressInformation.address3 !== '') {
                address += ' ' + this.$store.state.shipperAddressInformation.address3;
            }
            return address;
        },
        fullDeliveryAddress() {
            let address = this.$store.state.deliveryAddressInformation.address1;
            if (this.$store.state.deliveryAddressInformation.address2 !== '') {
                address += ' ' + this.$store.state.deliveryAddressInformation.address2;
            }
            if (this.$store.state.deliveryAddressInformation.address3 !== '') {
                address += ' ' + this.$store.state.deliveryAddressInformation.address3;
            }
            return address;
        },
        needsCommercialInvoice() {
            let vueThis = this;

            // NOTE Northern Ireland exception
            let northernIrelandRegex = /^BT/i;
         
            if (vueThis.$store.state.selectedFormType === 'mass') {
                let needs = false;
                $.each(vueThis.$store.state.massShipments, function (index, element) {
                    element.requiredCommercialInvoice = false;

                    if (element.Country === 'gb' && northernIrelandRegex.test(element.PostCode)) {
                       element.requiredCommercialInvoice = true;
                       needs = true;
                       return;
                    }
            
                    if (element.Country === 'mc') {
                        needs = true;
                        element.requiredCommercialInvoice = true;
                        return;
                    }
          
                    if (!vueThis.$helper.checkNotEu(element.Country)) {
                        needs = true;
                        element.requiredCommercialInvoice = true;
                        return;
                    }
                });

                if (needs) {
                    vueThis.$store.state.needCommercialInvoice = true;
                    vueThis.assignCommercialInvoiceUploadAreas();
                } else {
                    vueThis.$store.state.needCommercialInvoice = false;
                }

                return needs;
            }

            // NOTE Documents do not need an invoice
            if (vueThis.$store.state.otherDeliveryInformation.isDocuments) {
                return false;
            }
           
            // if (vueThis.$store.state.to.country === 'gb' && northernIrelandRegex.test(vueThis.$store.state.to.postCode)) {
            //     return false;
            // }
     
            if (vueThis.$store.state.to.country === 'mc') {
                return false;
            }

            return !vueThis.$helper.insideEu();
        },
        codAvailable() {
            let countries = [
                'ie', 'at', 'be', 'bg', 'cz', 'dk', 'ee', 'gr', 'es', 'it', 'cy', 'gr', 'lv', 'lt', 'pl', 'lu', 'mt', 'nl',
                'nl', 'pt', 'fr', 'ro', 'sk', 'si', 'fi', 'se', 'hu', 'de', 'li', 'no', 'ch'
            ];

            if (this.$store.state.from.country !== 'lt') {
                this.$store.state.otherDeliveryInformation.cashOnDelivery = false;
                return false;
            }

            if (!countries.includes(this.$store.state.to.country)) {
                this.$store.state.otherDeliveryInformation.cashOnDelivery = false;
                return false;
            }

            if (this.$store.state.otherDeliveryInformation.isDocuments) {
                return false;
            }

            if (this.$store.state.$siteSettings.customer_payment_type !== 'all') {
                return false;
            }

            return true;
        },
        saturdayDeliveryAvailable() {
            if (this.$store.state.from.country === 'lt' && this.$store.state.to.country === 'lt') {
                this.$store.state.otherDeliveryInformation.saturdayDelivery = false;
                return false;
            }

            if (this.$store.state.selectedShippingOption.serviceCode !== '07') {
                this.$store.state.otherDeliveryInformation.saturdayDelivery = false;
                return false;
            }

            return this.$store.state.selectedShippingOption.isSaturdayDeliveryAvailable;
        },
        codAmount() {
            let cashAmount = this.$store.state.otherDeliveryInformation.cashAmount;
            let onePercentOfCashAmount = parseFloat(cashAmount) * 0.01;
            let codServiceTax = parseFloat(this.$store.state.$siteSettings['Cod_tax'])

            if (codServiceTax < onePercentOfCashAmount) {
                return onePercentOfCashAmount;
            }

            return codServiceTax;
        },
        saturdayDeliveryTax() {
            return (parseFloat(this.$store.state.$siteSettings['Saturday_delivery_tax']) * (1 + (this.$store.state.selectedShippingOption.fuelChargePercentage))).toFixed(2);
        },
        signatureAvailable() {
            return this.$store.state.from.country === 'lt';
        },
        directDeliveryAvailable() {
            return this.$store.state.from.country === 'lt';
        },
        formattedEstimatedDelivery() {
            let time = moment(this.$store.state.selectedShippingOption.estimatedDelivery).locale(this.$store.state.$siteSettings['current_lang']);
            time = time.format(`dddd L[, ${this.$helper.trans('until')}] LT`);
            time = time.charAt(0).toUpperCase() + time.slice(1);
            return time.replace('23:30', this.$helper.trans('end_of_work'));
        },
        currencies() {
            let options = {};
            let splitCurrencies = this.$store.state.$siteSettings['Commercial_invoice_currencies'].split(',');
            $.each(splitCurrencies, function (index, element) {
                options[element.trim()] = element.trim();
            });

            return options;
        },
        isImport() {
            return this.$store.state.to.country === 'lt';
        },
        areBothLt() {
            return this.$store.state.to.country === 'lt' && this.$store.state.from.country === 'lt';
        }
    },
    watch: {
        '$store.state.otherDeliveryInformation.invoiceCurrency': async function() {
            this.checkCommercialInvoicePrice();
        },
        '$store.state.otherDeliveryInformation.saturdayDelivery': async function () {                 
            if (!this.$store.state.otherDeliveryInformation.saturdayDelivery && this.$store.state.inClientAdmin) {
                this.$store.state.selectedShippingOption.serviceCode = '';
                this.$helper.toggleAccordion(4);
            }
        },
        '$store.state.otherDeliveryInformation.commercialInvoiceType': function () {
            if (this.$store.state.otherDeliveryInformation.commercialInvoiceType === 'fill') {
                $('#commercial_invoice_modal').modal('show');
            }
        },
        '$store.state.currentActions.gettingShippingOptions': function () {
            let vueThis = this;
            if (!vueThis.quickEdit) {
                return;
            }

            let foundService = false;
            vueThis.errorMessage = false;

            if (vueThis.$store.state.currentActions.gettingShippingOptions) {
                return;
            }

            $.each(vueThis.$store.state.availableShippingOptions, function (index, shippingOption) {
                if (shippingOption.serviceCode === vueThis.$store.state.selectedShippingOption.serviceCode) {
                    foundService = true;
                    vueThis.$store.state.quickEditDimensions = false;
                    vueThis.$store.state.selectedShippingOption = shippingOption;
                    if (moment(shippingOption.estimatedDelivery).weekday() == 6 && vueThis.$store.state.selectedShippingOption.isSaturdayDeliveryAvailable) {
                        vueThis.$store.state.otherDeliveryInformation.saturdayDelivery = true;
                    }
                    return false;
                }
            });
            vueThis.quickEdit = false;

            if (!foundService) {
                vueThis.quickEditBtn = false;
                vueThis.errorMessage = vueThis.$helper.trans('Cant_find_price_by_selected_service');
            }

        },
        '$store.state.otherDeliveryInformation.packageValueDiff': function () {
            let vueThis = this;
            if (vueThis.$store.state.packagesDimensions.length > 1 && !vueThis.$store.state.otherDeliveryInformation.packageValueDiff) {
                $.each(vueThis.$store.state.packagesDimensions, function (index, item) {
                    vueThis.$store.state.packagesDimensions[index].insurance = '';
                });
                vueThis.$forceUpdate();
            }
        },
        '$store.state.otherDeliveryInformation.isDocuments': function () {
            if (!this.$store.state.otherDeliveryInformation.isDocuments && this.$store.state.packageType == '01') {
                this.$store.state.awaitingActions.selectNewOption = this.$store.state.selectedShippingOption.serviceCode;
                this.$store.state.packageType = '04';
                this.$store.state.customValues.letterSwapped = true;
            } else {
                this.$store.state.customValues.letterSwapped = false;
            }
        },
        '$store.state.otherDeliveryInformation': {
            handler(newValue) {
                this.$store.state.checkOutSteps.fifth = false;
            },
            deep: true
        },
        '$store.state.awaitingActions.selectNewOption': async function() {
            let vueThis = this;

            if (vueThis.$store.state.inClientAdmin) {
                return;
            }

            let newSelectedOption = this.$store.state.awaitingActions.selectNewOption;
            if (newSelectedOption === false) {
                return;
            }
                
            vueThis.$store.state.awaitingActions.selectNewOption = false;
            vueThis.$store.state.availableShippingOptions = [];
            
            await this.getSearchBackGroundOptions();

            let hasSameService = false;
            
            $.each(this.$store.state.availableShippingOptions, function (index, option) {                 
                if (option.serviceCode === newSelectedOption) {
                    hasSameService = true;
                    vueThis.selectShippingBackGroundOption(option, true); 
                    return true;
                }
            });          
            
            if (!hasSameService) {
                vueThis.$store.state.awaitingActions.hasSameService = false;
            }
            
        },
        '$store.state.from.postCode': function() {
            if(this.$store.state.from.country === 'mt'){
                this.$store.state.shipperAddressInformation.city = this.$helper.getMaltaCity(this.$store.state.from.postCode);
            }
        }
    }
}
</script>
